import { makeRequest } from "../http-common";

const DocDataService = {
  async getAll() {
    return makeRequest("get", "/doc/list");
  },

  async getById(id) {
    return makeRequest("get", `/doc/${id}`);
  },

  async getByRef(ref_type, ref_id) {
    return makeRequest("get", `/doc/byref/${ref_type}/${ref_id}`);
  },

  async create(data) {
    return makeRequest("post", "/doc", data);
  },

  async update(id, data) {
    return makeRequest("put", `/doc/${id}`, data);
  },

  async link(doc_id, link_id) {
    return makeRequest("post", `/doc/${doc_id}/link/${link_id}`);
  },

  async unlink(doc_id, link_id) {
    return makeRequest("post", `/doc/${doc_id}/unlink/${link_id}`);
  },  

  async getLinks(id) {
    return makeRequest("get", `/doc/${id}/links`);
  },

  async downloadPDF(id) {
    return makeRequest("get", `/doc/${id}/pdf`, {}, { responseType: 'blob' });
  },

};

export default DocDataService;